module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_8011.6d6e89d4.png";